import get from 'lodash/get';
import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

// PROJECT LOCATION
export const getCurrentProjectLocation = createSelector(
    getModel,
    (model) => model.currentProjectLocation,
);

export const getCurrentProjectLocationData = createSelector(
    getCurrentProjectLocation,
    (model) => model.data,
);

// SELECTED SEGMENT
export const getSelectedSegment = createSelector(
    getModel,
    (model) => model.selectedSegment,
);

export const getSelectedSegmentId = createSelector(
    getSelectedSegment,
    (model) => get(model, 'id', null),
);

// SAVE SEGMENT
export const getCreateSegment = createSelector(
    getModel,
    (model) => model.createSegment,
);

export const getIsSavingSegment = createSelector(
    getCreateSegment,
    (model) => model.isSaving,
);

export const getSaveSegmentErrors = createSelector(
    getCreateSegment,
    (model) => model.errors,
);

// CHECK SEGMENT
export const getCheckSegment = createSelector(
    getModel,
    (model) => model.checkSegment,
);

export const getIsCheckinSegment = createSelector(
    getCheckSegment,
    (model) => model.isSaving,
);

export const getCheckSegmentErrors = createSelector(
    getCheckSegment,
    (model) => model.errors,
);

// DELETE SEGMENT
export const getDeleteSegment = createSelector(
    getModel,
    (model) => model.deleteSegment,
);

export const getIsDeletingSegment = createSelector(
    getDeleteSegment,
    (model) => model.isDeleting,
);

export const getDeleteSegmentErrors = createSelector(
    getDeleteSegment,
    (model) => model.errors,
);

// EDIT SEGMENT
export const getUpdateSegment = createSelector(
    getModel,
    (model) => model.updateSegment,
);

export const getIsEditingSegment = createSelector(
    getUpdateSegment,
    (model) => model.isSaving,
);

export const getEditSegmentData = createSelector(
    getUpdateSegment,
    (model) => model.data,
);

export const getEditSegmentErrors = createSelector(
    getUpdateSegment,
    (model) => model.errors,
);

// PARENT FIELD SEGMENT
export const getParentFieldSegment = createSelector(
    getModel,
    (model) => model.fetchParentFieldSegment,
);

export const getIsFetchingParentFieldSegment = createSelector(
    getParentFieldSegment,
    (value) => value.isFetching,
);

export const getParentFieldSegmentData = createSelector(
    getParentFieldSegment,
    (value) => value.data || {},
);

// SEGMENTS
export const getSegmentsData = createSelector(
    getParentFieldSegmentData,
    (values) => values.segments || [],
);

export const getParentFieldSegmentCounters = createSelector(
    getParentFieldSegmentData,
    (values) => ({
        solarModulesDesignNumber: values.solarModulesDesignNumber,
        solarModulesOfferNumber: values.solarModulesOfferNumber,
    }),
);

export const getParentFieldSegmentErrors = createSelector(
    getParentFieldSegment,
    (value) => value.errors,
);

// OFFER INFO PATTERN
export const getOfferInfoPatern = createSelector(
    getModel,
    (model) => model.offerInfoPatern,
);

export const getIsFetchingOfferInfoPatern = createSelector(
    getOfferInfoPatern,
    (value) => value.isFetching,
);

export const getOfferInfoPaternData = createSelector(
    getOfferInfoPatern,
    (value) => value.data,
);

// OFFER PANELS
export const getOfferPanels = createSelector(
    getModel,
    (model) => model.offerPanels,
);

export const getIsFetchingOfferPanels = createSelector(
    getOfferPanels,
    (offerInfo) => offerInfo.isFetching,
);

export const getOfferPanelsCounters = createSelector(
    getOfferPanels,
    (offerInfo) => offerInfo.counters || {},
);

export const getOfferPanelsData = createSelector(
    getOfferPanels,
    (offerInfo) => offerInfo.data || {},
);

export const getOfferPanelsErrors = createSelector(
    getOfferPanels,
    (offerInfo) => offerInfo.errors,
);

/** DISABLED/ENABLE EDITION */
export const getIsDisabledEdition = createSelector(
    getModel,
    (model) => model.isDisabledEdition,
);

// GENERATE PROPOSAL
export const getGenerateProposal = createSelector(
    getModel,
    (model) => model.generateProposal,
);

export const getIsGeneratingProposal = createSelector(
    getCreateSegment,
    (model) => model.isFetching,
);

export const getAddSegmentModalOpenStatus = createSelector(
    getModel,
    (model) => model.addSegmentModalOpenStatus,
);

export const getAltitude = createSelector(getModel, (model) => model.altitude);

export const getCurrentValues = createSelector(
    getModel,
    (model) => model.currentValues,
);

export const getHasGroupsConfigErrors = createSelector(
    getModel,
    (model) => model.hasGroupsConfigErrors,
);

export const getGridConfig = createSelector(
    getModel,
    (model) => model.gridConfig,
);
